import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_HOWITWORKS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_HOWITWORK,
  UPDATE_HOWITWORK,
  DELETE_HOWITWORK,
  GET_HOWITWORK_PROFILE
 } from "./actionTypes";
import {
  getHowitworksSuccess,
  getHowitworksFail,
  addHowitworkSuccess,
  addHowitworkFail,
  updateHowitworkSuccess,
  updateHowitworkFail,
  deleteHowitworkSuccess,
  deleteHowitworkFail,
  getHowitworkProfileSuccess,
  getHowitworkProfileFail
  // getHowitworkProfileSuccess,
  // getHowitworkProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getHowitworks,
  // getHowitworkProfile,
  addNewHowitwork,
  updateHowitwork,
  deleteHowitwork,
  // getHowitworkProfile
} from "../../helpers/backend_helper";
import { setDataEdit, showPopup } from "../popup/actions";

function* fetchHowitworks({payload}) {
  try {
    const response = yield call(getHowitworks,payload);
    yield put(getHowitworksSuccess(response));
  } catch (error) {
    yield put(getHowitworksFail(error));
  }
}

// function* fetchHowitworkProfile({payload}) {
//   try {
//     const response = yield call(getHowitworkProfile,payload);
//     yield put(getHowitworkProfileSuccess(response));
//     yield put(setDataEdit(response.coveredLocation))
//   } catch (error) {
//     yield put(getHowitworkProfileFail(error));
//   }
// }

function* onUpdateHowitwork({ payload: { howitwork } }) {
  try {
   let response = yield call(updateHowitwork, howitwork);
   if(response.file_src || howitwork.removeImage) howitwork.image = response.file_src
    yield put(updateHowitworkSuccess(howitwork));
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(updateHowitworkFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onDeleteHowitwork({ payload: howitwork }) {

  
  try {
     let response = yield call(deleteHowitwork, howitwork);
    yield put(deleteHowitworkSuccess(howitwork));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteHowitworkFail(error));
    yield put(showPopup({ title: error.response.data.message, error: true }));
    

  }
}

function* onAddNewHowitwork({ payload: { user }}) {
  try {
    let response = yield call(addNewHowitwork, user)
    yield put(addHowitworkSuccess(response.data))
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(addHowitworkFail(error))
      // yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchHowitworkProfile() {
//   try {
//     const response = yield call(getHowitworkProfile);
//     yield put(getHowitworkProfileSuccess(response));
//   } catch (error) {
//     yield put(getHowitworkProfileFail(error));
//   }
// }

function* howitworksSaga() {
  yield takeEvery(GET_HOWITWORKS, fetchHowitworks);
  // yield takeEvery(GET_HOWITWORK_PROFILE, fetchHowitworkProfile);
  yield takeEvery(ADD_NEW_HOWITWORK, onAddNewHowitwork);
  yield takeEvery(UPDATE_HOWITWORK, onUpdateHowitwork);
  yield takeEvery(DELETE_HOWITWORK, onDeleteHowitwork);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchHowitworkProfile);
}

export default howitworksSaga;
